/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetUserCoursesOptions, GetUserCoursesResponses } from '../../models/GetUserCourses'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Get courses for a user.
 * This endpoint is intended for org admins to view courses of users in their org.
 * @summary Get User Courses
 * {@link /user/:user_id/courses}
 */
export function getUserCourses<ThrowOnError extends boolean = true>(options: Options<GetUserCoursesOptions, ThrowOnError>): Promise<UnwrappedResult<GetUserCoursesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/user/{user_id}/courses', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetUserCoursesResponses, ThrowOnError>>
}
